module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > Internet Popover > Connected.412b5a5e.jpg";